import { createTimeline } from 'animejs';

export default function Split_Image_Animation(container_el) {
	const image_el = container_el.querySelector(`img`);
	if (!image_el) {
		return;
	}

	const cursor_left_el = container_el.querySelector(`.cursor-left`);

	const cursor_right_el = container_el.querySelector(`.cursor-right`);

	if (!cursor_left_el || !cursor_right_el) {
		return;
	}

	const text_els = container_el.querySelectorAll(`p`);

	const delay = 300;

	const tl = createTimeline({
		autoplay: false,
	});
	const left_img = image_el.cloneNode(true);

	const right_img = image_el.cloneNode(true);

	image_el.style.visibility = `hidden`;

	Object.assign(left_img.style, {
		position: `absolute`,
		top: 0,
		left: 0,
		clipPath: `polygon(0 0, 100% 0, 0 100%)`,
		willChange: `transform`,
	});

	container_el.appendChild(left_img);

	Object.assign(right_img.style, {
		position: `absolute`,
		top: 0,
		left: 0,
		clipPath: `polygon(100% 100%, 0 100%, 100% 0)`,
		willChange: `transform`,
	});

	container_el.appendChild(right_img);

	tl.add(
		cursor_left_el,
		{
			opacity: 1,
			duration: delay,
		},
		0,
	);

	tl.add(
		cursor_right_el,
		{
			opacity: 1,
			duration: delay,
		},
		0,
	);

	tl.add(
		cursor_left_el,
		{
			translateY: -8,
			duration: 600,
		},
		delay * 1.5,
	);

	tl.add(
		left_img,
		{
			translateY: -8,
			duration: 600,
		},
		delay * 1.5,
	);

	tl.add(
		right_img,
		{
			translateY: 8,
			duration: 600,
		},
		delay * 1.5,
	);

	tl.add(
		cursor_right_el,
		{
			translateY: 8,
			duration: 600,
		},
		delay * 1.5,
	);

	for (const text_el of text_els) {
		tl.add(
			text_el,
			{
				opacity: 1,
				duration: 600,
			},
			delay * 1.5 + 600,
		);
	}

	return tl;
}
